import { BaseWebComponentTranslator } from '../../../framework/BaseWebComponentTranslator';
import { Feature } from '@nirvana/shared/constants';

export function getTranslatedProductsHubDescriptionText(): string {
  const translator = BaseWebComponentTranslator.getInstance();

  return (
    translator.translateFn(
      'Discover new products without leaving the console! Enjoy easy access to free, fully-featured 30-day product trials.'
    ) +
    (Application.Main.hasFeatures([Feature.PRODUCT_FEATURE_IN_PRODUCT_BUY])
      ? ' ' +
        translator.translateFn('If you decide to purchase a product, you can conveniently do so directly from the hub.')
      : '')
  );
}
